import { useSelector } from 'react-redux';
import type { RootState } from '../../../grid/reduxStore/Store.ts';
import { useTextBlockSelected } from '../../../EditorMenu/useTextBlockSelected.ts';
import { TableSettingsTypes } from '../../../SidePanel/content/TableSettings/types.ts';
import { useActiveEditor } from '../ActiveEditorContext.tsx';
import { useContext } from 'react';
import { SelectionContext } from '../../SelectedBlockInfoProvider.tsx';

export const useGetTipTapToolbarStatus = (): boolean => {
  const { activeEditor: editor, isEditMode } = useActiveEditor();
  const { selectedBlockIdByWrapper } = useContext(SelectionContext);
  const isActiveTextBlock = useTextBlockSelected();
  const isTiptapBlockEqualsToSelected = editor?.options?.editorProps.attributes?.['blockId'] === selectedBlockIdByWrapper;
  const { activeSidePanel } = useSelector((state: RootState) => state.blockStyleSettings);
  const isActiveRowsPanel = activeSidePanel === TableSettingsTypes.TABLE_ROWS || activeSidePanel === TableSettingsTypes.TABLE_FOOTER_ROWS;
  const isTableMenuBarActive = isActiveRowsPanel && !!editor;
  const isTextBlockMenuBarActive = isActiveTextBlock && editor !== null && isTiptapBlockEqualsToSelected;
  const isTableCellEditorActive = isEditMode && editor !== null && editor.storage?.tiptapAiExtension?.isTableCellEditor === true;
  return isTableMenuBarActive || isTextBlockMenuBarActive || isTableCellEditorActive;
};
